import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import {  IconLayoutDashboard, IconPlug, IconPalette, IconUserCircle, IconHeart, IconUsers, IconPhotoPlus } from "@tabler/icons-react";

const MainDashboardContent = ({ id, tabs, page }) => {
    const [activeTab, setActiveTab] = useState(null);

    useEffect(() => {
        tabs.forEach((tab) => {
            if (tab.page === page) {
                setActiveTab(tab);
            }
        });
    }, [page, tabs]);

    return (
        <>
            <div className="invoice-header d-flex align-items-center border-bottom p-3">
                <h4 className=" text-uppercase mb-0">{page}</h4>
                <div className="ms-auto">
                    <h4 className="invoice-number"></h4>
                </div>
            </div>
            <div className="p-3">
              {activeTab && activeTab.controller && <activeTab.controller singleArgs={activeTab?.args ?? false}/>}
            </div>
        </>
    );
};

export default MainDashboardContent;
